<script lang="ts">
	let {
		title = "Success Story",
		quote = "I've made over $3,000 this year just from photos I took during my delivery routes! It's so easy - I just snap a pic when I see a run-down house.",
		author = "Maria, DoorDash Driver"
	}: { title?: string; quote?: string; author?: string } = $props();
</script>

<div class="animate-fade-in-up-delay-3 rounded-lg border bg-white p-6 shadow-sm">
	<h4 class="text-muted-foreground mb-3 text-sm font-medium tracking-wide uppercase">
		{title}
	</h4>
	<p class="text-gray-600 italic">
		"{quote}"
	</p>
	<p class="text-foreground mt-2 font-medium">- {author}</p>
</div>
